import React from "react";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import { getBadgesMinimal, getCaseLabel, getIsApplicationComplete } from "../../../../services/Product/ProductService/productService";
import externalsCaseHeaderStyle from "./externalsCaseHeaderStyle";
import BadgesList from "../../../Badges/BadgesList";
import AgentPicker from "../../../AgentPicker/AgentPicker";
import { useBackofficeUser } from "../../../../provider/BackofficeUserProvider";
import CaseAdditionalClientsTooltipIcon from "../../../Case/CaseAdditionalClientsTooltipIcon/CaseAdditionalClientsTooltipIcon";
import CaseSubBarInfo from "../../../Case/CaseSubBarInfo/CaseSubBarInfo";
import { ProductUnion } from "../../../../types/ProductUnion";

type ExternalsCaseHeaderProps = {
  product: ProductUnion;
};
const ExternalsCaseHeader = ({ product }: ExternalsCaseHeaderProps) => {
  const { backofficeUsers, accountManagers, lawyers } = useBackofficeUser();

  if (!backofficeUsers) {
    return null;
  }

  const isApplicationComplete = getIsApplicationComplete(product);

  return (
    <Paper sx={externalsCaseHeaderStyle.caseHeaderContainer}>
      <Grid container>
        <Grid
          sx={{ paddingTop: "1rem" }}
          size={{
            xs: 12,
            lg: 7
          }}>
          <Stack direction={"row"} spacing={1}>
            <Typography variant="h1">{getCaseLabel(product)}</Typography>
            <CaseAdditionalClientsTooltipIcon product={product} fontSize={"large"} />
          </Stack>
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 5
          }}>
          <Grid container>
            <Grid
              size={{
                xs: 12,
                lg: 6
              }}>
              {isApplicationComplete && (
                <AgentPicker
                  label={"Legal"}
                  currentAgent={product.backofficeCase?.lawyer!}
                  product={product}
                  type={"lawyer"}
                  agentList={lawyers}
                  disabled
                />
              )}
            </Grid>
            <Grid
              size={{
                xs: 12,
                lg: 6
              }}>
              <AgentPicker
                label={"Operations"}
                currentAgent={product.backofficeCase?.accountManager!}
                product={product}
                type={"accountManager"}
                agentList={accountManagers}
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12}>
          <BadgesList badges={getBadgesMinimal(product)} />
          <CaseSubBarInfo product={product} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ExternalsCaseHeader;
